import { INavConfigDropdownLink } from '@pendwa/common-browser/components/Navs/Nav/types.js';
import { IContextPageDataViewer } from '@pendwa/common-browser/context/PageData/index.js';
import { rootRoutes } from '@pendwa/common/core/rootRoutes/index.js';
import { filterOutNullOrUndefined } from '@pendwa/common/utils/isDefinedAndNotNull.js';

export const moreLinks = (_params: { viewer?: IContextPageDataViewer }): INavConfigDropdownLink[] => {
  return filterOutNullOrUndefined([
    domain_env_pendwa_app && browserRootConfig.pendwa_app.credit_system.agent_purchase_tz
      ? {
          label: 'Voucher',
          navigate: {
            description: 'Purchase or activate a voucher.',
            href: rootRoutes.app.voucher.main.get(),
          },
        }
      : undefined,
    {
      label: 'Pair Device',
      navigate: {
        description: 'Pair a device to your account.',
        href: rootRoutes.app.pair.main.get(),
      },
    },
  ]);
};
